export default __webpack_public_path__ + "static/media/profile.71eb08ce.svg";